import React from 'react'
// import { NavLink as Link } from 'react-router-dom'
import styled from 'styled-components'
import logo from './contact-us.png';
const ABOUT = styled.article`
  flex: 1;
  overflow: auto;
  padding-bottom: 1em;
  scroll-behavior: smooth;
  .description > .title {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 32em;
    h1 {
      flex: 1;
      margin: 0;
      > a {
        color: inherit;
        text-decoration: none;
        &:hover, &:focus {
          text-decoration: underline;
        }
      }
    }
  }
  .description {
    max-width: 32em;
    position: relative;
    h1 {
      text-transform: uppercase;
      font-size: 1.75em;
      line-height: 1;
    }
    z-index: 4;
    padding: 1em;
    background: var(--main-bg-alpha);
    backdrop-filter: blur(3px);
    margin: auto;
    border-radius: 1em;
  }
`

function About() {
  return (<ABOUT>
    <div className="description">
    <h1>Contact</h1>
    <p>
    Want to partner, advertise or contribute a clipping to the archive? Reach out! 
    <br/>
    <a>contact@pessimistsarchive.org</a>
    <br/><br/><br/>
    </p>
    </div>
    <img src={logo} alt="image" width="80%" />
  </ABOUT>)
}

export default About
